/*
 * Jira Ticket:
 * Created Date: Thu, 9th Jul 2020, 16:22:59 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */
import React, { Fragment } from 'react';
import { Typography } from '@material-ui/core';

const PendingInvitesModalContent = ({ approvalUrl, classes, translate }) => {
  return (
    <Fragment>
      <Typography color="primary" variant="h5">
        {translate('resources.Organisation.fields.pendingInvitesTitle')}
      </Typography>
      <p>{translate('resources.Organisation.fields.pendingInvitesMessage')}</p>
    </Fragment>
  );
};

export default PendingInvitesModalContent;
